import { apiRequest } from "@/shared/lib/apiClient";

/* Lignes de la facture détaillée (saisie, import CSV, lecture automatique par Claude) : l'auditeur lance le
   traitement ; l'Admin peut aussi saisir en secours. */

export type EntryScope = "admin" | "auditor";

export type EntryLine = {
  id?: number;
  date: string;
  patient_name: string;
  patient_ref: string;
  label: string;
  quantity: number;
  amount: number;
  /** Diagnostic écrit sur la facture pour ce patient (facultatif). */
  diagnosis?: string;
  /** Ligne déjà codée par l'Audit (code acte posé). */
  coded?: boolean;
  /** Bénéficiaire du portefeuille rattaché (d'office ou par l'Audit). */
  beneficiary?: string | null;
};

export type EntryLinesResponse = {
  lines: EntryLine[];
  editable: boolean;
  extraction_available: boolean;
  extraction_configured: boolean;
  totals: { lines: number; declared: number | null; difference: number | null; currency: string };
};

export type ExtractionResult = {
  lines: EntryLine[];
  currency: string;
  total_detected: number;
  notes: string;
};

export async function fetchEntryLines(invoiceId: number, scope: EntryScope = "admin"): Promise<EntryLinesResponse> {
  return apiRequest(`/${scope}/invoices/${invoiceId}/entry-lines`, { auth: true });
}

export async function saveEntryLines(invoiceId: number, lines: EntryLine[], scope: EntryScope = "admin"): Promise<EntryLinesResponse> {
  return apiRequest(`/${scope}/invoices/${invoiceId}/entry-lines`, {
    method: "PUT",
    auth: true,
    body: {
      lines: lines.map(({ id, date, patient_name, patient_ref, label, quantity, amount, diagnosis }) => ({
        id,
        date,
        patient_name,
        patient_ref,
        label,
        quantity,
        amount,
        diagnosis: diagnosis ?? "",
      })),
    },
  });
}

export async function parseEntryLinesCsv(invoiceId: number, file: File, scope: EntryScope = "admin"): Promise<{ lines: EntryLine[]; errors: string[] }> {
  const form = new FormData();
  form.append("file", file);
  return apiRequest(`/${scope}/invoices/${invoiceId}/entry-lines/parse`, { method: "POST", auth: true, body: form });
}

export async function extractEntryLines(invoiceId: number, scope: EntryScope = "admin"): Promise<ExtractionResult> {
  return apiRequest(`/${scope}/invoices/${invoiceId}/entry-lines/extract`, { method: "POST", auth: true });
}
